const STORAGE_KEY = "konstrulog:lastActivityAt";

const DEFAULT_INACTIVITY_TIMEOUT_MS = 3 * 60 * 60 * 1000;

const ACTIVITY_THROTTLE_MS = 30_000;

let lastTouchWriteAt = 0;

export function getInactivityTimeoutMs(): number {
  const env = import.meta.env.VITE_INACTIVITY_TIMEOUT_MS;
  if (env) {
    const parsed = Number(env);
    if (!Number.isNaN(parsed) && parsed > 0) return parsed;
  }
  return DEFAULT_INACTIVITY_TIMEOUT_MS;
}

export function getLastActivityAt(): number | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function touchActivity(options?: { force?: boolean }): void {
  const now = Date.now();
  if (!options?.force && now - lastTouchWriteAt < ACTIVITY_THROTTLE_MS) return;
  lastTouchWriteAt = now;
  try {
    localStorage.setItem(STORAGE_KEY, String(now));
  } catch {
    /* ignore quota / private mode */
  }
}

export function clearActivity(): void {
  lastTouchWriteAt = 0;
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

/** True when last activity exceeds the configured idle timeout. Missing timestamp is not idle (migration). */
export function isSessionIdle(): boolean {
  const last = getLastActivityAt();
  if (last === null) return false;
  return Date.now() - last > getInactivityTimeoutMs();
}
